// extracted by mini-css-extract-plugin
export default {"overlay":"DialogFrame_overlay__K-gIZ","dialog":"DialogFrame_dialog__unqdf","head":"DialogFrame_head__SbTrz","close":"DialogFrame_close__4nvVk"};